import { notifications } from '@mantine/notifications';
import {
  transactionCategoryKeys,
  useCreateTransactionCategory,
} from 'api-hooks/transaction-category';
import { NavigationRoutes } from 'common/constants';
import { PreviousNavigation } from 'common/helpers/previous-navigation';
import { queryClient } from 'common/repositories/query-client';
import useGetCrudPermission from 'hooks/use-get-crud-permission';
import useNavigation from 'hooks/use-navigation';

import TransactionCategoryForm from './components/form';

export default function TransactionCategoryCreate() {
  const { navigate, back } = useNavigation();
  const createMutation = useCreateTransactionCategory();
  const permission = useGetCrudPermission('transaction-categories');

  return (
    <TransactionCategoryForm
      saveMutation={createMutation}
      onSubmit={async (input) => {
        const result = await createMutation.mutateAsync(input);
        queryClient.refetchQueries(transactionCategoryKeys.index());
        const prevPath = PreviousNavigation.get();
        if (prevPath) {
          PreviousNavigation.remove();
          back();
        } else if (permission.view) {
          navigate(NavigationRoutes.TransactionCategoriesView, {
            id: result.data?.id,
          });
        }
        notifications.show({ message: result?.message, color: 'green' });
        return result.data;
      }}
    />
  );
}
